export const pageAuthorizedMock = [
    'agendamento-medico',
    'agendamento-medico-ambulatorio',
    'backoffice-agencia-transfusional',
    'backoffice-agendamento',
    'backoffice-agendamento-triagem',
    'backoffice-autorizacao',
    'backoffice-cadastro-medico',
    'backoffice-chat',
    'backoffice-contratos',
    'backoffice-farmacia',
    'backoffice-mapa-cirurgico',
    'backoffice-notificacoes',
    'backoffice-orcamento',
    'backoffice-power-bi',
    'backoffice-pre-anestesico',
    'backoffice-regulacao',
    'backoffice-suprimentos',
    "backoffice-configuracao-de-sala",
    "backoffice-mapa-cirurgico-grade",
    "backoffice-motivo-recusa-orcamento",
    "backoffice-operadora-convenio",
    "backoffice-procedimento-hospital-dia",
    "backoffice-tempo-cirurgico-por-procedimento",
    'contratos-hospitais',
    'solicitacao-cirurgia',
    "carga-hospital-dia",
    "operadora-fidelizacao",
    "relatorio",
    'suporte',
];

export const rolesMock = [
    'agendamentoSecretariaNotificacao',
    'assinarEnviar',
    'backoffice-alterar-cadastro-medico',
    'backoffice-chat-agendamento',
    'backoffice-chat-autorizacao',
    'backoffice-mapa-agendamento',
    'backoffice-mapa-anestesia',
    'backoffice-mapa-autorizacao',
    'backoffice-mapa-centralmateriaisespeciais',
    'backoffice-mapa-centrocirurgico',
    'backoffice-mapa-cirurgia-realizada',
    'backoffice-mapa-engenhariaclinica',
    'backoffice-mapa-farmacia',
    'backoffice-mapa-gerenciamentoleito',
    'backoffice-mapa-hotelaria',
    'backoffice-mapa-opme',
    'backoffice-mapa-preinternacao',
    'backoffice-mapa-suprimentos',
    'backoffice-mapa-tesouraria',
    'instrumentador',
 
];
